import request from '@/fetch/index'

// 获取全省市区列表
function fetchBankInfor(body) {
  return request({
    url: '/api/loan/theBeltAndRoad/foreignBankInfoPage',
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: body
  })
}

function fetchProductTypes() {
  return request({
    url: '/api/loan/theBeltAndRoad/foreignBankProductTypes',
    method: 'GET'
  })
}

function fetchProductTable(body) {
  return request({
    url: '/api/loan/theBeltAndRoad/foreignBankProductPage',
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: body
  })
}

function fetchBankDetail(id) {
  return request({
    url: `/api/loan/theBeltAndRoad/foreignBankInfoDetail/${id}`,
    method: 'GET'
  })
}

function fetchProductDetail(id) {
  return request({
    url: `/api/loan/theBeltAndRoad/foreignBankProductDetail/${id}`,
    method: 'GET'
  })
}

export {
  fetchBankInfor,
  fetchProductTypes,
  fetchProductTable,
  fetchBankDetail,
  fetchProductDetail
}
